

import { APIResponse, Competition, PageModel } from '@brg/api';
import { PageModelPaging } from '@brg/api/dist/api-core/types/Generic';
import { createSlice } from '@reduxjs/toolkit';
import { fetchCompetitionProjects } from 'shared/actions/competition';

export interface CompetitionSliceStates {
    competitionList?: APIResponse<PageModel<Competition<'Local'>>>[]
    pagingCom?: APIResponse<PageModel<PageModelPaging>>
    vsList?: APIResponse<PageModel<Competition<'Local'>>>[]
    fairList?: APIResponse<PageModel<Competition<'Local'>>>[]
    data?: APIResponse<PageModel<Competition<'Local'>>>[]
    pagingVs?: APIResponse<PageModel<PageModelPaging>>
    isLoading: boolean;
}

export const CompetitionsSlice = createSlice({
    name: 'competitions',
    initialState: {
        competitionList: undefined,
        vsList: undefined,
        fairList: undefined,
        pagingCom: undefined,
        pagingVs: undefined,
        data: [],
        isLoading: false
    },
    reducers: {
        setComptitionsList: (state, action) => {
            state.competitionList = action.payload.data;
            state.pagingCom = action.payload.paging;
        },
        setVsList: (state, action) => {
            state.vsList = action.payload.data;
            state.pagingVs = action.payload.paging;
        },
        setFairList: (state, action) => {
            state.fairList = action.payload.data;
            state.pagingCom = action.payload.paging;
        },
    },
    extraReducers: {
        [fetchCompetitionProjects.fulfilled.toString()]: (state, action) => {
            const { contexts } = action.payload;
            //@ts-ignore
            state.data = action.payload.data?.data;

            // if (contexts.includes('main') || contexts.includes('creativelab') || contexts.includes('hsecompetition') ) {
            //     state.competitionList = action.payload.data?.data;
            //     state.pagingCom = action.payload.data?.paging;
            // } else if (contexts.includes('hsevisualresearch')) {
            //     state.vsList = action.payload.data?.data;
            //     state.pagingVs = action.payload.data?.paging;
            // }
            
            state.isLoading = false;
        },
        [fetchCompetitionProjects.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchCompetitionProjects.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },
    }
});

export default CompetitionsSlice
export const CompetitionsActions = CompetitionsSlice.actions
export const CompetitionsSelector = (store: { competitions: CompetitionSliceStates }): CompetitionSliceStates => store.competitions;


import { APIResponse, Competition, PageModel } from '@brg/api';
import { PageModelPaging } from '@brg/api/dist/api-core/types/Generic';
import { createSlice } from '@reduxjs/toolkit';
import { fetchCompetitionProjects } from 'shared/actions/competition';

export interface CompetitionSliceStates {
    competitionList?: APIResponse<PageModel<Competition<'Local'>>>[]
    pagingCom?: APIResponse<PageModel<PageModelPaging>>
    vsList?: APIResponse<PageModel<Competition<'Local'>>>[]
    fairList?: APIResponse<PageModel<Competition<'Local'>>>[]
    data?: APIResponse<PageModel<Competition<'Local'>>>[]
    pagingVs?: APIResponse<PageModel<PageModelPaging>>
    isLoading: boolean;
}

export const CompetitionsSlice = createSlice({
    name: 'competitions',
    initialState: {
        competitionList: undefined,
        vsList: undefined,
        fairList: undefined,
        pagingCom: undefined,
        pagingVs: undefined,
        data: [],
        isLoading: false
    },
    reducers: {
        setComptitionsList: (state, action) => {
            state.competitionList = action.payload.data;
            state.pagingCom = action.payload.paging;
        },
        setVsList: (state, action) => {
            state.vsList = action.payload.data;
            state.pagingVs = action.payload.paging;
        },
        setFairList: (state, action) => {
            state.fairList = action.payload.data;
            state.pagingCom = action.payload.paging;
        },
    },
    extraReducers: {
        [fetchCompetitionProjects.fulfilled.toString()]: (state, action) => {
            const { contexts } = action.payload;
            //@ts-ignore
            state.data = action.payload.data?.data;

            // if (contexts.includes('main') || contexts.includes('creativelab') || contexts.includes('hsecompetition') ) {
            //     state.competitionList = action.payload.data?.data;
            //     state.pagingCom = action.payload.data?.paging;
            // } else if (contexts.includes('hsevisualresearch')) {
            //     state.vsList = action.payload.data?.data;
            //     state.pagingVs = action.payload.data?.paging;
            // }
            
            state.isLoading = false;
        },
        [fetchCompetitionProjects.rejected.toString()]: (state, action) => {
            state.isLoading = false;
        },
        [fetchCompetitionProjects.pending.toString()]: (state, action) => {
            state.isLoading = true;
        },
    }
});

export default CompetitionsSlice
export const CompetitionsActions = CompetitionsSlice.actions
export const CompetitionsSelector = (store: { competitions: CompetitionSliceStates }): CompetitionSliceStates => store.competitions;
